import {
  HOME_SEND_MAIL_BEGIN,
  HOME_SEND_MAIL_SUCCESS,
  HOME_SEND_MAIL_FAILURE,
  HOME_SEND_MAIL_DISMISS_ERROR,
} from './constants';

export function sendMail(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: HOME_SEND_MAIL_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const doRequest = args.error ? Promise.reject(new Error()) : Promise.resolve();
      doRequest.then(
        (res) => {
          dispatch({
            type: HOME_SEND_MAIL_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: HOME_SEND_MAIL_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissSendMailError() {
  return {
    type: HOME_SEND_MAIL_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_SEND_MAIL_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        sendMailPending: true,
        sendMailError: null,
      };

    case HOME_SEND_MAIL_SUCCESS:
      // The request is success
      return {
        ...state,
        sendMailPending: false,
        sendMailError: null,
      };

    case HOME_SEND_MAIL_FAILURE:
      // The request is failed
      return {
        ...state,
        sendMailPending: false,
        sendMailError: action.data.error,
      };

    case HOME_SEND_MAIL_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        sendMailError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/sendMail.js